import auth from './reducers/auth';
import common from './reducers/common';
import menu_actions from './reducers/menu_actions';
import { combineReducers } from 'redux';
//import { routerReducer } from 'react-router-redux';

const appReducer = combineReducers({
  auth,
  common,
  menu_actions
  /* your app’s top-level reducers */
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined
  }

  return appReducer(state, action)
}
export default rootReducer
// export default combineReducers({
//   auth,
//   common,
//   order,
//     //router: routerReducer
//   });